import i18n from 'i18next';
import { initReactI18next  } from 'react-i18next';
import english from 'UserRegistration/resources/i18n/messages/en';
import french from 'UserRegistration/resources/i18n/messages/fr';

export const defaultNS = 'DEFAULT';

const fallbackLanguage = 'en';

// Attempt to read the language from the root <html> element, otherwise use the fallback language.
const language = document.documentElement.attributes.lang ? document.documentElement.attributes.lang.value : fallbackLanguage;

i18n.use(initReactI18next)
    .init({
        debug: false,
        defaultNS: defaultNS,
        fallbackLng: fallbackLanguage,
        fallbackNS: defaultNS,
        interpolation: {
            escapeValue: false, // not needed for react!!
            formatSeparator: ','
        },
        keySeparator: false,
        lng: language,
        react: {
            wait: true
        },
        resources: {
            en: english,
            fr: french
        },
    }, (error) => {
        if (error) return console.error(error);
    });

export default i18n;

